import { render, staticRenderFns } from "./RetouchersMainPhotoBlock.vue?vue&type=template&id=1bf11525&"
import script from "./RetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
export * from "./RetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./RetouchersMainPhotoBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports